const $ = require('jquery');
let _markers = [];
let _infoWindow = null;
let _mapOptions = null, _boundary = null;
// Hide the map container initially
if (document.getElementById('map-canvas')) {
  document.getElementById('map-canvas').style.display = 'none';
}

let storage = '';
if (storage == '') {
  storage = window.localStorage;
  console.log('localStorage initilized');
  console.log(storage);
}


$(() => {
  let zoomInit = 6;
  if ($('body').hasClass('single-villas')) {
    zoomInit = 12;
  } else {
    zoomInit = 6;
  }
  if (document.getElementById('map-canvas')) {
    initMap(zoomInit);
  }
})

window.onload = function () {
  // let zoomInit = 6;
  // if ($('body').hasClass('single-villas')) {
  //   zoomInit = 12;
  // } else {
  //   zoomInit = 6;
  // }
  // if (document.getElementById('map-canvas')) {
  //   initMap(zoomInit);
  // }
};


async function initMap(zoomInit) {
  // console.log(zoomInit);
  document.getElementById('map-canvas').style.display = 'block';
  document.getElementById('maploader-container').style.display = 'none';
  if ("undefined" != typeof google) {
    _boundary = new google.maps.LatLngBounds, _mapOptions = {
      center: new google.maps.LatLng(dynamicmap._mapCenterLatitude, dynamicmap._mapCenterLongitude),
      zoom: zoomInit,
      disableDefaultUI: false, //remove google's buttons
      mapTypeControl: false,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.TOP_CENTER,
      },
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER,
      },
      scaleControl: true,
      streetViewControl: false,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP,
      },
      fullscreenControl: true,
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      }
    }, "undefined" != typeof _mapStyles && null != _mapStyles && (_mapOptions.styles = _mapStyles), _map = new google.maps.Map(document.getElementById("map-canvas"), _mapOptions);

    // comment this out to test
    // 
    // initZoomControl(_map);
    // initMapTypeControl(_map);
    // initFullscreenControl(_map);
    // zoomEvent(_map);
    // drop();
    // Create the DIV to hold the control.
    const centerControlDiv = document.createElement("div");
    // Create the control.
    if ($('body').hasClass('page-template-villas')) {
      dynamicmap._searchUsingMapButton = createCenterControl(_map);
      // Append the control to the DIV.
      centerControlDiv.appendChild(dynamicmap._searchUsingMapButton);
      _map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv);
    }
    console.log('initMap dynamicmap', dynamicmap);
    for (var e = dynamicmap._properties.length, t = 0; t < e; t++) {
      createMarker(_map, dynamicmap._properties[t].latitude, dynamicmap._properties[t].longitude, dynamicmap._properties[t].title, dynamicmap._properties[t].content, _boundary);
    }

    if (!$('body').hasClass('single-villas')) {
      _map.fitBounds(_boundary);
      // console.log(!$('body').hasClass('single-villas'));
    }

    markerCluster = new markerClusterer.MarkerClusterer({
      map: _map,
      markers: dynamicmap._markers
    });

    google.maps.event.addListenerOnce(_map, 'idle', function () {
      if (Object.keys(dynamicmap._properties).length !== 0) {
        getMarkersFromBounds(_map);//init ince the idle function that will triigger the iddle .this will help us for not loading ajax on  window.load
      }

      if (Object.keys(dynamicmap._properties).length === 0) {
        _map.setZoom(6);
        _map.setCenter(new google.maps.LatLng(parseFloat(37.9), parseFloat(23.5)));
        // console.log('typeof properties are empty');
      }

    });

  }

}


function getMarkersFromBounds(map) {
  // zoom_changed
  //dragend is also is running idle
  google.maps.event.addListener(map, 'idle', function () {
    let idleTimeout; // Variable to store the timeout
    clearTimeout(idleTimeout);
    // getMarkersFromBoundsHelper(idleTimeout, map);
    idleTimeout = setTimeout(function () {
      // console.log(dynamicmap._searchUsingMap);
      if (dynamicmap._searchUsingMap === 1) {
        // console.log('search using map ===1');
        let propertyIdsInBound = [];
        $('.villas-loader').addClass('loading');

        if (dynamicmap.all_properties.length > 0) {


          // console.log('using all properties from fresh results that came with overview');
          let markers = propertiesToMarkers(dynamicmap.all_properties, map); // get markers from properties
          if (Array.isArray(markers)) {
            // console.log('all markers is array');
            for (var i = 0; i < markers.length; i++) {
              if (map.getBounds().contains(markers[i].getPosition())) {
                // markers[i] in visible bounds
                propertyIdsInBound.push(dynamicmap.all_properties[i].property_id);
                // console.log(' is  in visible bounds');
                // console.log(markers[i].property_id);

              } else {
                // console.log(' is not in visible bounds');
                // console.log(allmarkers[i]);
              }
            }
          }
          // $('.villas-loader').hide();
          $('.villas-loader').removeClass('loading');
          updateVillas(propertyIdsInBound);
          // console.log(propertyIdsInBound);
        } else {
          //normal will never end up here .... but if it does
          ////by pass the ajax the dynamic map is localized on overview load
          ////If for a reason you got no resualts update the map using an ajax requests . . . .

          console.log('search using map === else');
          $('.villas-loader').addClass('loading');
          $.ajax({
            url: window.urls.ajax,
            type: 'post',
            data: {
              action: 'post_select2_search_using_map',

              // data: '',
              // data: propertyIdsInBound,
              // paged: 1
            },
            success: function (response) {
              $('.villas-loader').removeClass('loading');
              // $('.villas-loader').hide();
              // console.log('response properties from query ');
              // console.log(response);
              //  dynamicmap._properties = response.properties;

              // console.log('completed ajax requests, run properties to map conversion.....');

              let allmarkers = propertiesToMarkers(response._properties, map); // get markers from properties
              // console.log(response._properties);
              // console.log(dynamicmap._markers);
              clearMarkers(map);

              // console.log('cleared all markers.....');

              markerCluster = new markerClusterer.MarkerClusterer({
                map: map,
                markers: allmarkers
              });

              // console.log('added the new markers');

              //update the window variables 
              dynamicmap._properties = response.properties;
              dynamicmap._markers = allmarkers;

              // return false;
              if (Array.isArray(allmarkers)) {
                for (var i = 0; i < allmarkers.length; i++) {
                  // console.log(markers[i]);
                  if (map.getBounds().contains(allmarkers[i].getPosition())) {
                    // markers[i] in visible bounds
                    propertyIdsInBound.push(response._properties[i].property_id);
                  } else {
                    // markers[i] is not in visible bounds
                  }
                }
              }
              // console.log('properties in bounds', propertyIdsInBound);
              // console.log('you must update the main results page with the correct pagination of the inbounds ids ');
              // console.log('run wordpress query to update the overview results and apgination cross fingers');

              window.favourites.updateFavoriteButtons();
            },
            error: function () {
              console.log('could not make ajax call');
            }
          }).then(function () {
            // paginationCLicked();
            // updateVillas(propertyIdsInBound);
          });

        }
      } else {
        //this is where the search using is offf

      }

    }, 300);

  });
}


function propertiesToMarkers(properties, map) {
  // if (dynamicmap._markers === 'undefined' || true) {
  if (true) {
    // console.log('create markers');
    let markers = [];

    for (var i = 0; i < properties.length; i++) {
      // console.log({ lat: properties[i].latitude, lng: properties[i].longitude });
      let d = new google.maps.Marker({
        position: new google.maps.LatLng(properties[i].latitude, properties[i].longitude),
        // map: map,
        // animation: google.maps.Animation.DROP,
        // icon: {
        //   url: `data:image/svg+xml;base64,${btoa(svg)}`, anchor: new google.maps.Point(25, 25),
        // }
      });

      // console.log(properties[i].latitude);
      // console.log(properties[i].longitude);
      markers.push(d);
    }
    return markers;
  } else {
    // console.log('dynamic _markers defined');
    return dynamicmap._markers;
  }
}

function updateVillas(propertyIdsInBound, $page = 1, forceUpdate = false) {

  const $ = jQuery;
  let resultscontainer = $('.villas-overview');
  let formdata = $('.allvillas__form').serialize();

  $('.villas-loader').addClass('loading');
  // console.log(formdata + '++++++++++++++' + $page)
  $.ajax({
    url: window.urls.ajax,
    type: 'post',
    data: {
      action: 'post_select2_ids',
      data: propertyIdsInBound,
      paged: $page,
      forceupdate: forceUpdate
    },
    success: function (response) {
      // $('.villas-loader').hide();
      $('.villas-loader').removeClass('loading');
      $('.villas-overview__pagination').empty().append(response.pagination.html);
      if (propertyIdsInBound.length > 10) {
        $('.allvillas__total-items__number').empty().html('10');
      } else {
        $('.allvillas__total-items__number').empty().html(propertyIdsInBound.length);
      }
      $('.allvillas__total-items__total').empty().html(propertyIdsInBound.length);

      resultscontainer.empty().append(response.results);

      if (forceUpdate === true) {
        clearMarkers(_map);
        updateMarkers(_map, response.markers);
      }

      window.favourites.updateFavoriteButtons();
      // console.log('refresh');
    },
    error: function () {
      // console.log('could not make ajax call');
    }
  }).then(function () {
    // paginationCLicked();
  });
}


function zoomEvent(map) {
  /* Change markers on zoom */
  google.maps.event.addListener(map, 'zoom_changed', function () {
    var zoom = map.getZoom();
    var getCenter = map.getCenter();
    var getBounds = map.getBounds();
    //     console.log(getCenter);
    // 
    //     console.log(zoom);
    //     console.log(map);
    //     console.log(getBounds);
    //     console.log(getBounds);
    // var letlongBounds = map.LatLngBounds();

  });

}


//clear markers from properties
function clearMarkers(map) {
  if (dynamicmap._properties !== null) {
    for (var i = 0; i < dynamicmap._markers.length; i++) {
      dynamicmap._markers[i].setMap(null);
    }
    const clusters = [];
    if (markerCluster) {
      markerCluster.setMap(null);
    }
  } else {
    // console.log('not clearing markers');
  }
}

function updateMarkers(map, markers) {
  console.log('updateMarkers');
  console.log(map);
  clearMarkers(map);
  dynamicmap._markers = [];
  // dynamicmap._properties = [];
  let _boundary = new google.maps.LatLngBounds();
  // console.log(markers.length);
  console.log('updateMarkers markers', markers);
  for (var e = markers.length, t = 0; t < e; t++) {
    // console.log('updateMarkers', markers[t]); ok debug tested
    createMarker(map, markers[t].latitude, markers[t].longitude, markers[t].title, markers[t].content, _boundary);
    // map.fitBounds(_boundary);
    // console.log(test);
    // dynamicmap._properties.push({ 'property_id': markers[t].property_id, 'latitude': markers[t].latitude, 'longitude': markers[t].longitude, title: markers[t].title, 'content': markers[t].content });
  }

  map.fitBounds(_boundary);

  // console.log(dynamicmap._markers);
  updatemarkerCluster = new markerClusterer.MarkerClusterer({
    map: _map,
    markers: dynamicmap._markers
  });
  // map.setCenter();
  // map.fitBounds(_boundary);
  //  map.setZoom(12);
  // console.log(markers);

}

function createMarker(n, e, o, t, i, a, l, p) {
  // const timeout = 1000;
  let svg = `<svg fill="black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity="1" r="70" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">1</text>
</svg>`;
  const svgSinle = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 54 54">
  <g id="Group_1594" data-name="Group 1594" transform="translate(-473 -5848.875)">
    <circle id="Ellipse_164" data-name="Ellipse 164" cx="27" cy="27" r="27" transform="translate(473 5848.875)"/>
    <circle id="Ellipse_165" data-name="Ellipse 165" cx="11" cy="11" r="11" transform="translate(489 5864.875)" fill="#ffea84"/>
  </g>
</svg>`;

  if ($('body').hasClass('single-villas')) {
    svg = svgSinle;
  }

  var d = new google.maps.Marker({
    position: new google.maps.LatLng(e, o),
    map: n,
    animation: google.maps.Animation.DROP,
    icon: {
      url: `data:image/svg+xml;base64,${btoa(svg)}`, anchor: new google.maps.Point(25, 25),
    }
  });

  console.log('createMarker', d);

  dynamicmap._markers.push(d);

  return void 0 !== t && null !== t && d.setTitle(t), void 0 !== l && null !== l && d.setAnimation(l), void 0 !== i && null != i && (d.infowindow = new google.maps.InfoWindow({
    content: i
  }), google.maps.event.addListener(d, "click", function () {
    "undefined" != typeof _infoWindowExternalContainerId && null != _infoWindowExternalContainerId ? jQuery("#" + _infoWindowExternalContainerId).html(this.infowindow.getContent()) : (_infoWindow && _infoWindow.close(), _infoWindow = this.infowindow, this.infowindow.open(n, this))
  })), void 0 !== a && null !== a && a.extend(d.position), void 0 !== p && null !== p && d.setIcon(p), d


}

function clearDynamicFilters() {
  $('.allvillas__form--dynamicfilter--location__inputs__input input').prop('checked', false);
  $('.cmp-accordion01__header').removeClass('active');
  $('.cmp-accordion01__content').removeClass('open');
  $('.cmp-accordion01__content').css('height', 0);
  $('.allvillas__dynamic-selections').empty();
  const $bedroomsCurrent = $('.bedrooms-current');
  const $bedroomsInput = $('[name="bedrooms"]');
  $bedroomsCurrent.empty().html(0); //visible to user
  $bedroomsInput.val('0');
  //Clear Prices from and to 
  storage.setItem('City', '');
  storage.setItem('Bedrooms', '0');
  storage.setItem('SortBy', '');
  const $pricefrom = $('[name="pricefrom"]');
  const $priceto = $('[name="priceto"]');
  storage.setItem('PriceRange', { 'min': $priceto.val($priceto.attr('max')), 'max-price': $pricefrom.val($pricefrom.attr('min')) });

}
//Create a function that will re init the map when  a user clicks to activate the map 
function fullfillMapInBounds(map) {
  // console.log('try to fill the map and stay in bound');
  // console.log('you should also try to clear the filters by then ');
  let propertyIdsInBound = [];
  let markersinbound = [];
  // $('.villas-loader').show();
  $('.villas-loader').addClass('loading');

  if (dynamicmap.all_properties.length > 0) {
    // console.log(window);
    // console.log(window.dynamicmap);
    // console.log(dynamicmap.all_properties);
    // return false;

    // console.log('using all properties from fresh results that came with overview')
    let markers = propertiesToMarkers(dynamicmap.all_properties, map); // get markers from properties
    if (Array.isArray(markers)) {
      // console.log('all markers is array');
      for (var i = 0; i < markers.length; i++) {
        if (map.getBounds().contains(markers[i].getPosition()) || true) { //adding or true in order to get all the villas // and get all the markers
          // markers[i] in visible bounds
          propertyIdsInBound.push(dynamicmap.all_properties[i].property_id);
          markersinbound.push(markers[i]);
          // console.log(' is  in visible bounds');
          // console.log(markers[i].property_id);

        } else {
          // console.log(' is not in visible bounds');
          // console.log(allmarkers[i]);
        }
      }
    }
    // $('.villas-loader').hide();
    $('.villas-loader').removeClass('loading');
    clearMarkers(map);
    clearMarkers(map);
    updateVillas(propertyIdsInBound, 1, true); //update the results 
    // updateMarkers(map, markers); //update the markers in the map 
    // console.log(propertyIdsInBound);
    // console.log('clearfilters in this stage');
  }
}

/**
 * Creates a control that recenters the map on Chicago.
 */
function createCenterControl(map) {

  const greece = {
    lat: 38.14,
    lng: 24.32
  };
  const controlButton = document.createElement("button");

  // Set CSS for the control.
  // controlButton.style.backgroundColor = "#fff";
  // controlButton.style.color = "rgb(25,25,25)";

  controlButton.style.backgroundColor = "rgb(113 197 204)";
  controlButton.style.color = "black";

  controlButton.style.border = "1px solid #fff";
  controlButton.style.borderRadius = "2em";
  // controlButton.style.backgroundColor = "";
  controlButton.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
  controlButton.style.cursor = "pointer";
  controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
  controlButton.style.fontSize = "14px";
  controlButton.style.lineHeight = "22px";
  controlButton.style.margin = "8px 0 22px";
  controlButton.style.padding = "0 5px";
  controlButton.style.textAlign = "center";
  controlButton.textContent = "Search Using Map is On";
  controlButton.style.opacity = '1';
  controlButton.title = "Click search dynamically through maps";
  controlButton.type = "button";
  dynamicmap._searchUsingMap = 1;
  // Setup the click event listeners: simply set the map to Chicago.
  controlButton.addEventListener("click", () => {
    if (dynamicmap._searchUsingMap === 1) {
      dynamicmap._searchUsingMap = 0;
      controlButton.textContent = "Search Using Map is Off";
      controlButton.style.backgroundColor = "rgb(113 197 204)";
      controlButton.style.opacity = '0.5';
      controlButton.style.color = "black";
      controlButton.style.border = "1px solid rgb(113 197 204)";
      storage.setItem('SearchUsingMap', 0);
    } else {

      clearDynamicFilters();
      fullfillMapInBounds(map);
      dynamicmap._searchUsingMap = 1;
      storage.setItem('SearchUsingMap', 1);
      controlButton.style.backgroundColor = "rgb(113 197 204)";
      controlButton.style.color = "black";
      controlButton.style.border = "1px solid rgb(113 197 204)";
      controlButton.style.opacity = '1';
      controlButton.textContent = "Search Using Map is On";



      console.log("Add a function that will update alla the villas markers for this event...");



    }
  });
  return controlButton;
}

function initZoomControl(map) {
  document.querySelector(".zoom-control-in").onclick = function () {
    map.setZoom(map.getZoom() + 1);
  };

  document.querySelector(".zoom-control-out").onclick = function () {
    map.setZoom(map.getZoom() - 1);
  };

  map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(
    document.querySelector(".zoom-control")
  );
}

function initMapTypeControl(map) {
  const mapTypeControlDiv = document.querySelector(".maptype-control");

  document.querySelector(".maptype-control-map").onclick = function () {
    mapTypeControlDiv.classList.add("maptype-control-is-map");
    mapTypeControlDiv.classList.remove("maptype-control-is-satellite");
    map.setMapTypeId("roadmap");
  };

  document.querySelector(".maptype-control-satellite").onclick = function () {
    mapTypeControlDiv.classList.remove("maptype-control-is-map");
    mapTypeControlDiv.classList.add("maptype-control-is-satellite");
    map.setMapTypeId("hybrid");
  };

  map.controls[google.maps.ControlPosition.LEFT_TOP].push(mapTypeControlDiv);
}

function initFullscreenControl(map) {
  const elementToSendFullscreen = map.getDiv().firstChild;
  const fullscreenControl = document.querySelector(".fullscreen-control");

  map.controls[google.maps.ControlPosition.RIGHT_TOP].push(fullscreenControl);
  fullscreenControl.onclick = function () {
    if (isFullscreen(elementToSendFullscreen)) {
      exitFullscreen();
    } else {
      requestFullscreen(elementToSendFullscreen);
    }
  };

  document.onwebkitfullscreenchange =
    document.onmsfullscreenchange =
    document.onmozfullscreenchange =
    document.onfullscreenchange =
    function () {
      if (isFullscreen(elementToSendFullscreen)) {
        fullscreenControl.classList.add("is-fullscreen");
      } else {
        fullscreenControl.classList.remove("is-fullscreen");
      }
    };
}

function isFullscreen(element) {
  return (
    (document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement) == element
  );
}

function requestFullscreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.webkitRequestFullScreen) {
    element.webkitRequestFullScreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.msRequestFullScreen) {
    element.msRequestFullScreen();
  }
}

function exitFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}

$('.allvillas__form--dynamicfilter .dropdown').on('click', function (e) {
  e.stopPropagation();
  e.preventDefault();
  $(this).closest('.collection-wrapper').find('[data-level=1]').toggleClass('visible');
  $(this).closest('[data-accordion-content]').height('auto');
});